<template>
  <component
    :is="type === 'textarea' ? 'textarea' : 'input'"
    :key="name"
    :value="value"
    v-bind="this.$attrs"

    @input="handleInput"
  />
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import { FormInputProps } from './FormInput.types';

export default Vue.extend({
  props: {
    // eslint-disable-next-line vue/require-prop-types
    value: {
      required: true,
    },
    type: {
      type: String as PropType<FormInputProps['type']>,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleInput(): void {
      const element = (this.$el as HTMLInputElement | HTMLTextAreaElement);
      this.$emit('input', element.value);
    },
  },
});
</script>
